<script>
import ConversationCardV2 from 'dashboard/components/widgets/conversation/ConversationCardV2.vue';
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    ConversationCardV2,
    Spinner,
  },
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    conversations() {
      return this.$store.getters['contactConversations/getContactConversation'](
        this.contactId
      );
    },
    previousConversations() {
      return this.conversations.filter(
        conversation => conversation.id !== Number(this.conversationId)
      );
    },
    // 获取当前会话的状态 - 从conversations store获取
    currentConversationStatus() {
      const currentConversation = this.$store.getters['getConversationById'](
        Number(this.conversationId)
      );
      return currentConversation?.status;
    },
    ...mapGetters({
      uiFlags: 'contactConversations/getUIFlags',
    }),
  },
  watch: {
    contactId(newContactId, prevContactId) {
      if (newContactId && newContactId !== prevContactId) {
        this.$store.dispatch('contactConversations/get', newContactId);
      }
    },
    // 监听当前会话状态变化，当状态变更时刷新conversations列表
    currentConversationStatus(newStatus, oldStatus) {
      if (newStatus && newStatus !== oldStatus) {
        // 当当前会话状态发生变化时，刷新整个conversations列表
        this.$store.dispatch('contactConversations/get', this.contactId);
      }
    },
    // 监听conversationId变化，确保状态同步
    conversationId(newId, oldId) {
      if (newId && newId !== oldId) {
        // 当conversationId变化时，也刷新conversations列表以确保数据同步
        this.$store.dispatch('contactConversations/get', this.contactId);
      }
    },
  },
  mounted() {
    this.$store.dispatch('contactConversations/get', this.contactId);
  },
};
</script>

<template>
  <div class="contact-conversation--panel">
    <div v-if="!uiFlags.isFetching" class="contact-conversation__wrap">
      <div
        v-if="!previousConversations.length"
        class="no-label-message px-4 p-3"
      >
        <span>
          {{ $t('CONTACT_PANEL.CONVERSATIONS.NO_RECORDS_FOUND') }}
        </span>
      </div>
      <div v-else class="contact-conversation--list">
        <ConversationCardV2
          v-for="conversation in conversations"
          :key="conversation.id"
          :chat="conversation"
          :hide-inbox-name="false"
          hide-thumbnail
          show-assignee
          class="compact"
        />
      </div>
    </div>
    <Spinner v-else />
  </div>
</template>

<style lang="scss" scoped>
.no-label-message {
  @apply text-slate-500 dark:text-slate-400 mb-4;
}

::v-deep .conversation {
  @apply pr-0;
  .conversation--details {
    @apply pl-2;
  }
  
  // 修复ConversationCardV2的右内边距问题
  &.conversation-card-v2 {
    @apply pr-4;
  }
}
</style>
